import script from "./IngredientList.vue?vue&type=script&setup=true&lang=js"
export * from "./IngredientList.vue?vue&type=script&setup=true&lang=js"

import "./IngredientList.vue?vue&type=style&index=0&id=554f4523&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-554f4523"]])

export default __exports__